import generalUpload from "../_section/upload.class";
import dayjs from "dayjs";

export class userEDSUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [
        {
            name: 'year',
            label: 'Year',
            type: 'text',
        }, {
            name: 'grossBasic',
            label: 'Gross Basic',
            type: 'currency',
            optional: true,
        }, {
            name: 'grossBasic1',
            label: 'Gross Basic 2',
            type: 'currency',
            optional: true,
        }, {
            name: 'grossBasic2',
            label: 'Gross Basic 3',
            type: 'currency',
            optional: true,
        }, {
            name: 'employer1',
            label: 'Employer 1',
            type: 'text',
            optional: true,
        }, {
            name: 'pay1',
            label: 'Pay 1',
            type: 'currency',
        }, {
            name: 'start1',
            label: 'Start 1',
            type: 'date',
        }, {
            name: 'end1',
            label: 'End 1',
            type: 'date',
            optional: true,
        }, {
            name: 'employer2',
            label: 'Employer 2',
            type: 'text',
            optional: true,
        }, {
            name: 'pay2',
            label: 'Pay 2',
            type: 'currency',
            optional: true,
        }, {
            name: 'start2',
            label: 'Start 2',
            type: 'date',
            optional: true,
        }, {
            name: 'end2',
            label: 'End 2',
            type: 'date',
            optional: true,
        }, {
            name: 'employer3',
            label: 'Employer 3',
            type: 'text',
            optional: true,
        }, {
            name: 'pay3',
            label: 'Pay 3',
            type: 'currency',
            optional: true,
        }, {
            name: 'start3',
            label: 'Start 3',
            type: 'date',
            optional: true,
        }, {
            name: 'end3',
            label: 'End 3',
            type: 'date',
            optional: true,
        }
    ]
}

export class adminEDSUpload extends userEDSUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.year) {
            let first = dayjs(`${this.values.year}-01-01`);
            this.setDateData({
                dated: first.endOf('year'),
                expires: first.add(3, 'year').endOf('year'),
            })
        }
    }
}
